import _extends from "@babel/runtime/helpers/extends";
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { RadioBoxGroup as CoreRadioBoxGroup } from '@vds-core/inputs';
import { BodyConfig, TypographyConfig } from '@vds/typography';
import { calculateRem } from '@uie/javascript-style-helpers';
import { colors, calculateSpacing } from '@vds/theme';
var typescale = TypographyConfig.getTypescale();
var minHeight = calculateRem(44);
var innerPadding = calculateSpacing('3X');

function _calcTypography(typescale, stacked, component) {
  return BodyConfig.getStyles(typescale, 'desktop', 'small');
}

var propTypes = {
  /**
   * If provided, RadioBox components will be rendered based on this data
   * @typeName radioBoxData
   */
  data: PropTypes.arrayOf(PropTypes.shape({
    text: PropTypes.string,
    subtext: PropTypes.string,
    name: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    disabled: PropTypes.bool,
    outOfStock: PropTypes.bool,
    onChange: PropTypes.func,
    selected: PropTypes.bool,
    id: PropTypes.string
  })),

  /**
   * If provided, the RadioBox Group Items will either stack or render horizontally
   */
  orientation: PropTypes.oneOf(['vertical', 'horizontal']),

  /**
   * If provided, the RadioBox Group Items will have a set height, applied only for the vertical orientation
   */
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};
var defaultProps = {
  orientation: 'horizontal'
};

var RadioBoxGroup = function RadioBoxGroup(props) {
  var orientation = props.orientation,
      height = props.height,
      outOfStock = props.outOfStock;
  return /*#__PURE__*/React.createElement(CoreRadioBoxGroup, _extends({}, props, {
    height: orientation === 'vertical' ? height : undefined,
    minHeight: minHeight,
    padding: innerPadding,
    labelMargin: false,
    hoverState: true,
    disabledState: true,
    activeState: true,
    focusState: true,
    typescale: typescale,
    calcTypography: _calcTypography,
    borderColor: colors.coolGray6,
    outOfStock: outOfStock,
    backgroundColor: colors.white
  }));
};

RadioBoxGroup.propTypes = propTypes;
export default RadioBoxGroup;